 <div class="search-container" (click)="$event.stopPropagation()">
    <div class="search-wrapper">
        <mat-icon class="search-icon">search</mat-icon>
        <input type="text" class="search-input" placeholder="Search" [(ngModel)]="searchTerm" [ngModelOptions]="{standalone: true}" (input)="onSearchInput($event.target.value)" aria-label="Search"/>
        @if(searchTerm){
            <button mat-icon-button class="clear-button" (click)="clearSearch()" aria-label="Clear search">
                <mat-icon>close</mat-icon>
            </button>
        }
        <div class="divider"></div>
        <button mat-icon-button [matMenuTriggerFor]="filterMenu" class="filter-button" aria-label="Filter options">
            <mat-icon>tune</mat-icon>
        </button>
    </div>

    <mat-menu #filterMenu="matMenu" class="filter-menu">
        <div class="filter-header" (click)="$event.stopPropagation()">
            <span>Filters</span>
        </div>
        <mat-divider></mat-divider>
        <div class="filter-options" (click)="$event.stopPropagation()">
            @for(option of filterOptions(); track option){
            <div class="filter-option">
            <mat-checkbox [(ngModel)]="option.selected" [ngModelOptions]="{standalone: true}" (change)="onFilterChange()">
                {{ option.label }}
            </mat-checkbox>
            </div>
            }
        </div>
    </mat-menu>
</div>